import http from "../../http-common";


export default class JobApplicationService {
    static applyJob(data) {
        return http.post("/job/apply", data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
    }


}